// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\nh1 {\n  margin-bottom: 0.75rem;\n}\n.nav-tabs {\n  margin-bottom: 40px;\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
